import { clsx } from 'clsx'
import React, { forwardRef } from 'react'

const styles = {
  base: [
    // Basic layout
    'relative isolate',
    // Sizing
    'w-full',
  ],
}

export const Fieldset = forwardRef(function Fieldset(
  {
    className,
    ...props
  }: {
    className?: string
  } & React.ComponentPropsWithoutRef<'fieldset'>,
  ref: React.ForwardedRef<HTMLFieldSetElement>
) {
  return (
    <fieldset
      {...props}
      className={clsx(styles.base, className)}
      ref={ref}
    />
  )
})

export const Legend = forwardRef(function Legend(
  {
    className,
    ...props
  }: {
    className?: string
  } & React.ComponentPropsWithoutRef<'legend'>,
  ref: React.ForwardedRef<HTMLLegendElement>
) {
  return (
    <legend
      {...props}
      className={clsx(
        'text-sm/6 font-semibold text-gray-900 dark:text-white',
        className
      )}
      ref={ref}
    />
  )
})
